import React, { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useMetricTestClient } from '../../hooks';

export default function MetricTestPage() {
  const metricTestClient = useMetricTestClient();
  const { isPending, isError, data, error } = useQuery({
    queryKey: ['metricTest'],
    queryFn: () => metricTestClient.metricTest(),
  });

  useEffect(() => {
    document.title = 'Metric Test';
  }, []);

  if (isPending) return <pre>loading...</pre>;
  if (isError) return <pre>{JSON.stringify({ error: (error as Error)?.message }, null, 2)}</pre>;

  return <pre>{JSON.stringify(data?.data, null, 2)}</pre>;
}
